module.exports = __webpack_public_path__ + "img/logo.9c45e817.png";